import { render } from "./page-flashcards.vue?vue&type=template&id=06ec4a7d&scoped=true"
import script from "./page-flashcards.vue?vue&type=script&lang=js"
export * from "./page-flashcards.vue?vue&type=script&lang=js"

import "./page-flashcards.vue?vue&type=style&index=0&id=06ec4a7d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06ec4a7d"

export default script